import React from 'react';
import { defineMessages } from 'react-intl';
import useFormatMessage from 'hooks/useFormatMessage';
import { routingTip, routingTipTitle, routingTipClose } from './styles/styles.module.scss';

enum RoutingTypes {
  SMART_TIP = 'SMART_TIP',
  DRAW_TIP = 'DRAW_TIP',
  NODE_TIP = 'NODE_TIP'
}

const ROUTING_TIP_STRINGS = defineMessages({
  SMART_TIP: { defaultMessage: 'Smart Routing:' },
  DRAW_TIP: { defaultMessage: 'Drawing Mode:' },
  NODE_TIP: { defaultMessage: 'Tip:' },
  TIP_BUTTON_LABEL: { defaultMessage: 'Close Routing Tips' },
  SMART_TIP_TEXT: { defaultMessage: 'We will route you on the best path for your selected activity' },
  DRAW_TIP_TEXT: { defaultMessage: "Hold 'shift' to free draw" },
  NODE_TIP_TEXT: { defaultMessage: "Hit the 'delete' / \u232B key to remove a point from your route." }
});

type Props = {
  onClose: (tipType: string, event: any) => void;
  tipType: string;
};

const RoutingTip = ({ tipType, onClose }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { SMART_TIP, DRAW_TIP, NODE_TIP, TIP_BUTTON_LABEL, SMART_TIP_TEXT, DRAW_TIP_TEXT, NODE_TIP_TEXT }
  } = useFormatMessage(ROUTING_TIP_STRINGS);

  const getRoutingTipTitle = (): string => {
    switch (tipType) {
      case RoutingTypes.SMART_TIP:
        return SMART_TIP;
      case RoutingTypes.DRAW_TIP:
        return DRAW_TIP;
      case RoutingTypes.NODE_TIP:
        return NODE_TIP;
      default:
        return SMART_TIP;
    }
  };

  const getRoutingTipText = (): string => {
    switch (tipType) {
      case RoutingTypes.SMART_TIP:
        return SMART_TIP_TEXT;
      case RoutingTypes.DRAW_TIP:
        return DRAW_TIP_TEXT;
      case RoutingTypes.NODE_TIP:
        return NODE_TIP_TEXT;
      default:
        return SMART_TIP_TEXT;
    }
  };

  const title = getRoutingTipTitle();
  const text = getRoutingTipText();
  return (
    <div className={routingTip}>
      <span className={routingTipTitle}>{title}</span>&nbsp;{text}
      <button type="button" title={TIP_BUTTON_LABEL} aria-label={TIP_BUTTON_LABEL} onClick={e => onClose(tipType, e)} className={routingTipClose} />
    </div>
  );
};

export default RoutingTip;
